export default __webpack_public_path__ + "static/media/Voltage_Reference.a8499556.svg";